export const subappToName = {
    "/messages": "Messages",
    "/documents": "Documents",
    "/bookings": "Bookings",
};
const messagesAppearingInTasks = (tasks) => tasks.flatMap((t) => messagesById[t.id]
    ? [{ id: t.id, ...messagesById[t.id] }]
    : []);
export const tasksByIdSrc = {
    "message-bob-easy-1": {
        name: "Respond to the message from Bob",
        subapp: "/messages",
    },
    "message-john-easy-2": {
        name: "Respond to the message from John",
        subapp: "/messages",
    },
    "message-alexis-med-1": {
        name: "Respond to the message from Alexis",
        subapp: "/messages",
    },
    "message-josie-med-2": {
        name: "Respond to the message from Josie",
        subapp: "/messages",
    },
    "message-josh-hard-1": {
        name: "Respond to the message from Josh",
        subapp: "/messages",
    },
    "message-priya-hard-2": {
        name: "Respond to the message from Priya",
        subapp: "/messages",
    },
    "schedule-meeting-easy-1": {
        name: "Schedule a meeting on Dec 7 at 1 pm",
        subapp: "/bookings",
        completedOn: {
            type: "scheduleEventAt",
            date: "2023-12-07",
            time: "13:00",
        },
    },
    "schedule-meeting-easy-2": {
        name: "Schedule a hour long meeting on Dec 8 at 2 pm",
        subapp: "/bookings",
        completedOn: {
            type: "scheduleEventAt",
            date: "2023-12-08",
            time: "14:00",
        },
    },
    "schedule-exam-med-1": {
        name: "Schedule your final for APSC 123 based on the time in the syllabus",
        subapp: "/documents",
        caption: "",
        completedOn: {
            type: "scheduleEventAt",
            date: "2024-04-18",
            time: "17:30",
        },
    },
    "schedule-exam-med-2": {
        name: "Schedule your midterm 2 for APSC 123 based on the time in the syllabus",
        subapp: "/documents",
        caption: "",
        completedOn: {
            type: "scheduleEventAt",
            date: "2024-03-20",
            time: "08:00",
        },
    },
    "schedule-exam-med-3": {
        name: "Schedule your midterm 1 for APSC 123 based on the time in the syllabus",
        subapp: "/documents",
        caption: "",
        completedOn: {
            type: "scheduleEventAt",
            date: "2024-01-20",
            time: "08:00",
        },
    },
};
export const tasksById = Object.fromEntries(Object.entries(tasksByIdSrc).map(([k, v]) => [k, { id: k, ...v }]));
const messagesById = {
    "message-bob-easy-1": {
        from: "Bob",
        content: "What is your favourite colour?",
        subject: "Picking colours",
    },
    "message-john-easy-2": {
        from: "John",
        content: "What is your favourite animal?",
        subject: "Favourite animal",
    },
    "message-alexis-med-1": {
        from: "Alexis",
        content: "When were the lecture 5 slides uploaded?",
        subject: "Lecture 5 slides",
    },
    "message-josie-med-2": {
        from: "Josie",
        content: "When were the lecture 2 slides uploaded?",
        subject: "Lecture 2 slides",
    },
    "message-josh-hard-1": {
        from: "Josh",
        content: "Can you remind me what the title of Lecture 1 was for APSC 123?",
        subject: "Lecture title",
    },
    "message-priya-hard-2": {
        from: "Priya",
        content: "Can you remind me what was the homework for APSC 123 lecture 5?",
        subject: "Homework?",
    },
};
const initialTaskIds1 = [
    "message-john-easy-2",
    "message-alexis-med-1",
    "message-priya-hard-2",
    "schedule-exam-med-2",
    "schedule-meeting-easy-1",
];
const initialTaskIds2 = [
    "message-bob-easy-1",
    "message-josh-hard-1",
    "schedule-exam-med-1",
    "message-josie-med-2",
    "schedule-meeting-easy-2",
];
const initialTasks1 = initialTaskIds1.map((i) => tasksById[i]);
const initialTasks2 = initialTaskIds2.map((i) => tasksById[i]);
const initialMessages1 = messagesAppearingInTasks(initialTasks1);
const initialMessages2 = messagesAppearingInTasks(initialTasks2);
const initialDocuments1 = [
    {
        date: "Jan 4 2024",
        path: "/file-content/APSC 123 syllabus.png",
        title: "Syllabus (APSC 123)",
    },
    {
        date: "Jan 4 2024",
        path: "/file-content/LIT 420 Syllabus.png",
        title: "Syllabus (LIT 420)",
    },
    {
        date: "Jan 4 2024",
        path: "/file-content/MATH 432 Syllabus.png",
        title: "Syllabus (MATH 432)",
    },
    {
        date: "Jan 8 2024",
        path: "/file-content/APSC 123 Lecture 1.png",
        title: "Lecture 1",
    },
    {
        date: "Jan 10 2024",
        path: "/file-content/APSC 123 Lecture 2.png",
        title: "Lecture 2",
    },
    {
        date: "Jan 12 2024",
        path: "/file-content/APSC 123 Lecture 3.png",
        title: "Lecture 3",
    },
    {
        date: "Jan 15 2024",
        path: "/file-content/APSC 123 Lecture 4.png",
        title: "Lecture 4",
    },
    {
        date: "Jan 17 2024",
        path: "/file-content/APSC 123 Lecture 5.png",
        title: "Lecture 5",
    },
    {
        date: "Jan 19 2024",
        path: "/file-content/APSC 123 Lecture 6.png",
        title: "Lecture 6",
    },
    {
        date: "Jan 22 2024",
        path: "/file-content/APSC 123 Lecture 7.png",
        title: "Lecture 7",
    },
    {
        date: "Jan 24 2024",
        path: "/file-content/APSC 123 Lecture 8.png",
        title: "Lecture 8",
    },
];
export const experiment1 = {
    tasks: initialTasks1,
    messages: initialMessages1,
    documents: initialDocuments1,
};
export const experiment2 = {
    tasks: initialTasks2,
    messages: initialMessages2,
    documents: initialDocuments1,
};
